import React from 'react'
import { useFormContext } from 'react-hook-form'

import { formatCurrency } from 'utils/formatters'
import Button from 'common/Button'

export default ({ resource, cart, submitting, saving }) => {
  const { watch } = useFormContext()

  const totalWatch = watch('cartTotal')
  const transport = watch('transport')
  const itemsTotal = totalWatch === undefined ? cart.total : totalWatch
  const transportFee = transport?.amount ?? 0
  const grandTotal = (itemsTotal || 0) + transportFee

  return (
    <div className="filler mt-5 p-1">
      {transportFee > 0 && (
        <div className="d-flex align-items-center justify-content-between mb-1 px-1">
          <span className="fs-14">{resource.Shipping}:</span>
          <span className="fs-14">{formatCurrency(transportFee, undefined, '€')}</span>
        </div>
      )}
      <div className="d-flex align-items-center justify-content-center mt-4 mb-3">
        <h5 className="webshop-title-color mb-0 fw-bolder">
          {resource.GrandTotal}: {formatCurrency(grandTotal, undefined, '€')}
        </h5>
      </div>
      <Button
        type="submit"
        color="primary"
        size="lg"
        className="w-100"
        disabled={submitting || saving}
        loading={submitting}
      >
        {resource.Checkout}
      </Button>
    </div>
  )
}
